import React from "react";

import USAID_Logo from "../../../Img/USAID_Logo.png";
import PEPFAR_Logo from "../../../Img/PEPFAR_Logo.jpg";
import SOAR_Logo from "../../../Img/SOAR_Logo.jpg";

class SCWelcomeForm extends React.Component {
    //==================================================================================================================
    //
    //                                                 Render
    //
    //==================================================================================================================

    render() {
        try {
            const styles = {
                start_page: {
                    padding: "10px",
                },
                col: {
                    width: "32%",
                    display: "inline-block",
                },
            };

            const text = {
                section1: {
                    p1: "The SCPT was developed under the technical leadership of Emmanuel Njeuhmeli (USAID, Washington DC), in collaboration with Project SOAR (Supporting Operational AIDS Research). Project SOAR is a Cooperative Agreement (AID-OAA-A-14-00060) led by the Population Council and made possible by the generous support of the American people through the President’s Emergency Plan for AIDS Relief (PEPFAR) and the United States Agency for International Development (USAID). This activity was implemented by Avenir Health (Michel Tchuenche, Mark Roman, Thomas Podkowiak, Robert McKinnon, Matthew Hamilton, Peter Stegman and Steven Forsythe). The contents of this tool are the sole responsibility of Project SOAR (Population Council, Avenir Health) (projsoar.org) and do not necessarily reflect the views of USAID or the United States Government.",

                    p2: "Project SOAR would like to acknowledge the support of VMMC stakeholders, implementing partners, USG country teams and Ministries of Health in eSwatini, Kenya, Lesotho, Malawi, Mozambique, Namibia, South Africa, Uganda and Zimbabwe. Special thanks go to Felix Nhaduco and Francisco Zita (Jhpiego/Mozambique), as well as all the reviewers who provided useful feedback on the tool interface.",
                },
                section2: {
                    title: "The Site Capacity and Productivity Assessment Tool (SCPT)",

                    p1: "The SCPT supports countries and stakeholders to assess the productivity and efficiency of VMMC sites in converting program inputs (staff time, commodities, space, etc.) into program outputs (circumcisions performed, utilization of facilities, etc.).  It can help improve the implementation efficiency of VMMC programs at facility level by identifying where programmatic resources (human resources, commodities, equipment, infrastructure, etc.) have been positioned for implementation and whether these resources have been arrayed strategically to meet program objectives/target, or if there may be places where potential resource gaps may exist. ",

                    p2: "The SCPT collects monthly VMMC related facility level data and generates analytics (in the form of downloadable tables and graphs) for program M&E and reporting.  These analytics provide VMMC facility and program managers with insights into where performance might be improved, for example:",
                    p2UL: {
                        li1: "Compare the number of VMMCs performed to the current service delivery capacity at each site",
                        li2: "Monitor the monthly utilization rate at each site",
                        li3: "Estimate the optimum personnel numbers and mix to maximize productivity of each site",
                        li4: "Monitor monthly productivity loss/gain by site",
                        li5: "Compare demand for VMMC services by site to the capacity of the site to meet the demand",
                    },

                    p3: "To use the SCPT, the user needs to specify the following – Country – Location(s) – Site characteristics – and Time period.",

                    p4Header: "Select a country: ",
                    p4: "The default country to which users have access will be selected. However, if users have access to multiple countries, they can select the country of interest.",

                    p5Header: "Locations: ",
                    p5: "Select the location of interest (specific site, SNU or Province)",

                    p6Header: "Characteristics: ",
                    p6: "Select the site characteristics of interest (Rural vs Urban, PEPFAR category, VMMC category, DREAMS, USG agencies, Implementing partners, Service delivery modes, and Ownership)",

                    p7Header: "Time period: ",
                    p7: "Select the time period for which the results will be displayed",
                    p7UL: {
                        li1: "Month (first and last month) for a specific year – Monthly outputs will be generated",
                        li2: "Quarter (first, second, third or fourth) for a specific year – Monthly inputs are aggregated to generate quarterly outputs",
                        li3: "Half-year for a specific year (monthly inputs are aggregated to generate semi-annual outputs)",
                        li4: "Year – Monthly input are aggregated to generate annual outputs.",
                    },
                },
                section3: {
                    title: "Results",

                    p1: "Each result can be displayed graphically, or as a table – the user can specify this with the radio buttons below each figure or table. Graphs are downloadable in various formats while tables can be copied directly and pasted in any document.",

                    p2Header: "Personnel and facility: ",
                    p2: "This section provides a snapshot of the available human resources, major equipment such as beds, and days of operation at each facility.",

                    p3Header: "Site capacity: ",
                    p3: "Assesses the average number of VMMCs performed daily, within the specified time period, against the current and optimum service delivery capacity of the site.",

                    p4Header: "Demand: ",
                    p4: "Presents on where VMMC clients got their VMMC information and compares the resources required at sites to meet the number of people seeking VMMC services.",

                    p5Header: "STIs and HIV: ",
                    p5: "Presents information on the STI and HIV status of VMMC clients, VMMC clients’ uptake of HIV testing, enrolment in care and treatment of VMMC clients who tested HIV+, among others, by site.",

                    p6Header: "VMMC service delivery: ",
                    p6: "Presents the performance of each site in terms of targets and achievements (over time, by age group, etc.), surgical method, follow-up, and adverse events.",

                    p7Header: "Productivity: ",
                    p7: "Presents service utilization rate and productivity gain/loss by site.",
                },
            };

            return (
                <div style={styles.start_page}>
                    <div style={styles.col}>
                        <img
                            src={USAID_Logo}
                            alt=""
                            style={{ maxHeight: "100px", padding: "0 20px" }}
                        />
                    </div>

                    <div style={styles.col}>
                        <div style={{ width: "200px", margin: "0 auto" }}>
                            <img
                                src={PEPFAR_Logo}
                                alt=""
                                style={{ maxHeight: "100px", padding: "0 20px" }}
                            />
                        </div>
                    </div>

                    <div style={styles.col}>
                        <img
                            src={SOAR_Logo}
                            alt=""
                            style={{ float: "right", maxHeight: "100px", padding: "0 20px" }}
                        />
                    </div>

                    <p id="Section1.p1">{text.section1.p1}</p>
                    <p id="Section1.p2">{text.section1.p2}</p>

                    <div id="Section2.title">
                        <h2>
                            <strong>{text.section2.title}</strong>
                        </h2>
                    </div>
                    <p id="Section2.p1">{text.section2.p1}</p>
                    <p id="Section2.p2">{text.section2.p2}</p>
                    <ul id="Section2.p2UL">
                        <li id="Section2.p2UL.li1">{text.section2.p2UL.li1}</li>
                        <li id="Section2.p2UL.li2">{text.section2.p2UL.li2}</li>
                        <li id="Section2.p2UL.li3">{text.section2.p2UL.li3}</li>
                        <li id="Section2.p2UL.li4">{text.section2.p2UL.li4}</li>
                        <li id="Section2.p2UL.li5">{text.section2.p2UL.li5}</li>
                    </ul>
                    <p id="Section2.p3">{text.section2.p3}</p>
                    <p id="Section2.p4Header+p4">
                        <strong>{text.section2.p4Header}</strong>
                        {text.section2.p4}
                    </p>
                    <p id="Section2.p5Header+p5">
                        <strong>{text.section2.p5Header}</strong>
                        {text.section2.p5}
                    </p>
                    <p id="Section2.p6Header+p6">
                        <strong>{text.section2.p6Header}</strong>
                        {text.section2.p6}
                    </p>
                    <p id="Section2.p7Header+p7">
                        <strong>{text.section2.p7Header}</strong>
                        {text.section2.p7}
                    </p>
                    <ul id="Section2.p7UL.li1">
                        <li id="Section2.p7UL.li1">{text.section2.p7UL.li1}</li>
                        <li id="Section2.p7UL.li2">{text.section2.p7UL.li2}</li>
                        <li id="Section2.p7UL.li3">{text.section2.p7UL.li3}</li>
                        <li id="Section2.p7UL.li4">{text.section2.p7UL.li4}</li>
                    </ul>

                    <div id="Section3.title">
                        <h2>
                            <strong>{text.section3.title}</strong>
                        </h2>
                    </div>
                    <p id="Section3.p1">{text.section3.p1}</p>
                    <p id="Section3.p2Header">
                        <strong>{text.section3.p2Header}</strong>
                        {text.section3.p2}
                    </p>
                    <p id="Section3.p3Header">
                        <strong>{text.section3.p3Header}</strong>
                        {text.section3.p3}
                    </p>
                    <p id="Section3.p4Header">
                        <strong>{text.section3.p4Header}</strong>
                        {text.section3.p4}
                    </p>
                    <p id="Section3.p5Header">
                        <strong>{text.section3.p5Header}</strong>
                        {text.section3.p5}
                    </p>
                    <p id="Section3.p6Header">
                        <strong>{text.section3.p6Header}</strong>
                        {text.section3.p6}
                    </p>
                    <p id="Section3.p7Header">
                        <strong>{text.section3.p7Header}</strong>
                        {text.section3.p7}
                    </p>
                </div>
            );
        } catch (exception) {
            return (
                <div
                    className={"SCWelcomeFormDiv"}
                    key={"SCWelcomeFormDiv"}
                >
                    <h3 key={"SCWelcomeFormDivH3"}>{exception.name + ": " + exception.message}</h3>
                </div>
            );
        }
    }
}

export default SCWelcomeForm;
